export type OpenXPopupOptions = {
  url: string;
  windowName?: string;
  width?: number;
  height?: number;
};

export function openXPopup({
  url,
  windowName = 'ShareOnX',
  width = 600,
  height = 600,
}: OpenXPopupOptions) {
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;

  window.open(
    url,
    windowName,
    `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars`
  );
}

/**
 * Opens a popup to share a post on X.
 * @param post The text content to share in the post.
 */
export function shareToX(post: string) {
  const encodedPost = encodeURIComponent(post);
  const shareUrl = `https://twitter.com/intent/tweet?text=${encodedPost}`;
  openXPopup({ url: shareUrl });
}
